var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 399,
    viewBox: "0 0 399 174",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0649 0 0 1.4471 -13.974 -.43989)",
    d: "m266.31 42.09a67.746 33.172 0 1 1 -135.49 0 67.746 33.172 0 1 1 135.49 0z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m115.85 52.089 2.7477-3.2029h159.18l3.1679 3.7387-165.1-0.53576z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m182.21 152.38h30.525v6.541h-30.525z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.2189 0 0 1.0334 -29.561 -12.7)",
    d: "m230.8 137.87a44.541 26.164 0 1 1 -89.082 0 44.541 26.164 0 1 1 89.082 0z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.99855 0 0 1.1435 4.5754 -31)",
    d: "m314.9 143.32a23.672 16.041 0 1 1 -47.344 0 23.672 16.041 0 1 1 47.344 0z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.99855 0 0 1.1435 -197.42 -31)",
    d: "m314.9 143.32a23.672 16.041 0 1 1 -47.344 0 23.672 16.041 0 1 1 47.344 0z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m115.87 51.91v33.561h165.23v-33.142l-165.23-0.41951z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.0036
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m89.348 98.212h216.4s-9.9383-3.1809-15.603-7.0587c-5.5799-3.8195-8.9162-7.0587-8.9162-7.0587h-166.06s-5.2595 4.6755-10.031 7.4302c-4.6845 2.7046-15.789 6.6872-15.789 6.6872z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8.5447 134.99h375.97s-2.9427-7.2634-19.318-16.718c-16.508-9.5307-61.299-21.919-61.299-21.919h-212.13s-47.36 12.642-62.785 21.547c-15.148 8.7454-20.433 17.089-20.433 17.089z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0184 0 0 1.6866 -5.7985 -43.729)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0184 0 0 1.6866 10.202 -43.729)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.87182 0 0 1.703 61.067 -44.81)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.90107 0 0 1.6996 -74.032 -44.586)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.90107 0 0 1.6996 -88.032 -44.586)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.41044 0 0 1.768 20.656 -49.113)",
    d: "m247.72 66.16a4.7468 2.8184 0 1 1 -9.4935 0 4.7468 2.8184 0 1 1 9.4935 0z",
    fill: "#fff",
    stroke: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m156.98 21.066h81.607",
    fill: "fff",
    stroke: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.555dab27536314c438b1240cf6ec5708.svg";
export { ForwardRef as ReactComponent };